import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Dialog from 'material-ui/Dialog';
import _ from 'lodash';
import validate from 'validate.js';
import HttpClient from 'services/HttpClient';
import {PageWrapper} from 'components/PageWrapper';
import TopicForm from '../components/TopicForm';
import {CLINICAL_NOTE_WRITING_TOPIC_CONSTRAINS} from 'constants/adminPupups';

const TopicUrl = '/api/v1/note_topics/';

@inject('clinicalNoteWritingTopicsStore')
@inject('alertStore')
@observer
class EditTopic extends Component {
  constructor() {
    super();

    this.state = {
      isConfirmModalOpened: false,
    };
  }

  componentDidMount() {
    const {match, clinicalNoteWritingTopicsStore: {setTopic}} = this.props;
    const id = match.params.topicId;

    if(id) {
      new HttpClient().get(`${TopicUrl}${id}`).then(data => {
        const topic = {
          ...data.body.data.note_topic,
          categoryId: data.body.data.note_topic.note_category_id,
          file: {
            file_url: data.body.data.note_topic.file_url
          }
        };

        setTopic(topic);
      }).catch(() => {
        this.props.alertStore.success('Something went wrong');
      });
    }
  }

  componentWillUnmount() {
    const {clinicalNoteWritingTopicsStore: {initNewTopic}} = this.props;

    initNewTopic();
  }

  handleChange = e => {
    const {clinicalNoteWritingTopicsStore} = this.props;

    if (e.target.name === 'file') {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.files[0]});
    } else {
      clinicalNoteWritingTopicsStore.handleChange({[e.target.name]: e.target.value});
    }
  };

  validationProcess = topic => {
    let errors = validate(topic, CLINICAL_NOTE_WRITING_TOPIC_CONSTRAINS, { fullMessages: false });

    return errors
  };

  submit = e => {
    e.preventDefault();

    const {clinicalNoteWritingTopicsStore, match} = this.props;
    const id = match.params.topicId;
    const topic = _.assign({}, clinicalNoteWritingTopicsStore.topic);
    const errors = this.validationProcess(topic);

    clinicalNoteWritingTopicsStore.setError(errors);

    if (errors) {
      return;
    }

    const formData = new FormData();
    formData.append('title', topic.title);
    formData.append('note_category_id', topic.categoryId);
    if (topic.file.name)
      formData.append('file', topic.file, topic.file.name);

    new HttpClient().multipart(`${TopicUrl}${id}`, formData, 'PUT').then(data => {
      clinicalNoteWritingTopicsStore.saveTopic(data.body.data.note_topic);
      this.props.alertStore.success('Topic successfully edited');
      this.props.history.push(`/clinical-notes-writing/${topic.categoryId}/edit`);
      
    }).catch(() => {
      this.props.alertStore.success('Something went wrong');
    });
  };

  deleteTopic = () => {
    const { alertStore, history, match } = this.props;
    const id = match.params.id;
    const topicId = match.params.topicId;

    new HttpClient().delete(`${TopicUrl}${topicId}`)
    .then(() => {
      alertStore.success('You successfully delete topic');
      history.push(`/clinical-notes-writing/${id}/edit`);
    });
  };

  handleOpenConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: true,
    });
  };

  handleCloseConfirmModal = () => {
    this.setState({
      isConfirmModalOpened: false,
    });
  };

  render() {
    const { isConfirmModalOpened } = this.state;

    return (
      <PageWrapper>
        <Dialog
          className="modal-wrapper category-handle"
          title='Are you sure you want to delete this topic?'
          modal={true}
          open={isConfirmModalOpened}
          customContentStyle={{
            height: '100%',
            maxHeight: 'none',
          }}
          bodyClassName="modal-content"
          repositionOnUpdate={true}
          autoDetectWindowHeight={true}
          autoScrollBodyContent={false}>
          <div className="button-set">
            <button
              className="btn gray small transparanted cancel-btn"
              type="reset"
              onClick={this.handleCloseConfirmModal}
            >
              No
            </button>
            <button
              className="btn gray small transparanted apply-btn"
              type="submit"
              onClick={this.deleteTopic}
            >
              Yes
            </button>
          </div>
        </Dialog>
        <button onClick={this.handleOpenConfirmModal} className='delete-btn'>delete topic</button>
        <TopicForm submit={this.submit} />
      </PageWrapper>
    );
  }
}

export default EditTopic;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/EditTopic.js